import { useEffect } from "react";
import { logEvent } from "@shared/analytics/analytics";
import { PageHeader } from "@shared/components/PageHeader";
import { ClipboardCheck } from 'lucide-react';
import { CardContent } from "@shared/ui/card";
import { useGetActivityLog } from "@features/wx/hooks";

interface TimelineTabProps {
  entityId: string;
  entityType: any;
}

export function ActivityLogTab({ entityId, entityType }: TimelineTabProps) {
  const { data: activityLogs } = useGetActivityLog(entityId, entityType);
  useEffect(() => {
    logEvent("activityLog_tab_viewed");
  }, []);
  return (
    <div>
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
          <ClipboardCheck className="h-5 w-5 text-indigo-600" />
        </div>
        <div>
          <PageHeader
            title="Activity Log"
            subtitle="Manage activity log for this request"
          />
        </div>
      </div>
      <CardContent>
        {activityLogs?.count === 0 ? (
          <div className="text-center p-8">
            <div className="h-10 w-10 text-gray-400 mx-auto mb-2 flex items-center justify-center">
              <svg
                className="h-8 w-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-600">
              No Timeline Events
            </h3>
            <p className="text-sm text-gray-500">
              No timeline events available for this request
            </p>
          </div>
        ) : (
          <div className="relative">
            {activityLogs?.results.map((event, index) => (
              <div key={index} className="mb-8 flex gap-4">
                <div className="relative mt-1.5">
                  <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 text-blue-600 ring-8 ring-white">
                    <div className="h-2.5 w-2.5 rounded-full bg-blue-600"></div>
                  </div>
                  {index < activityLogs.length - 1 && (
                    <div className="absolute top-6 bottom-0 left-1/2 -translate-x-1/2 w-0.5 h-full bg-gray-200"></div>
                  )}
                </div>
                <div className="flex-1">
                  <div className="flex flex-col sm:flex-row sm:justify-between">
                    <p className="font-medium">{event.title}</p>
                    <p className="text-sm text-muted-foreground">
                      {event.time}
                    </p>
                  </div>
                  {event.user && (
                    <p className="text-sm mt-0.5">By: {event.user.name}</p>
                  )}
                  {event.description && (
                    <p className="text-sm mt-2 text-muted-foreground">
                      {event.description}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </div>
  );
}
